import React, { useMemo, useEffect } from 'react';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import Keycloak from 'keycloak-js';
import TokenRefresher from './TokenRefresher';
import { TokenService } from './TokenService';
import appConfig from '../config/config';

const handleKeycloakEvent = (event, error) => {
  switch (event) {
    case 'onReady': console.log('[Keycloak] Ready state reached'); break;
    case 'onInitError': console.error('[Keycloak] Init Error:', error); break;
    case 'onAuthSuccess': console.log('[Keycloak] Auth Success'); break;
    case 'onAuthError': console.error('[Keycloak] Auth Error:', error); break;
    default: console.log('[Keycloak] Other event:', event); break;
  }
};

const handleKeycloakTokens = (tokens) => {
  if (tokens?.token) {
    TokenService.setToken(tokens.token);
  }
};

// Wrapper che utilizza il provider di @react-keycloak/web
const KeycloakProviderWrapper = ({ children }) => {
  const keycloakInstance = useMemo(() => {
    return new Keycloak({
      url: appConfig.keycloak.url, // Deve essere https://.../auth
      realm: appConfig.keycloak.realm,
      clientId: appConfig.keycloak.clientId,
      checkLoginIframe: false
    });
  }, []);


  return (
    <ReactKeycloakProvider
      authClient={keycloakInstance} // Istanza di Keycloak da utilizzare
      initOptions={{
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri: `${appConfig.APP_PATH}/silent-check-sso.html`,
        pkceMethod: 'S256',
      }}
      onEvent={handleKeycloakEvent}
      onTokens={handleKeycloakTokens}
    >
      <TokenRefresher />
      {children}
    </ReactKeycloakProvider>
  );
};

export default KeycloakProviderWrapper;